<div
  #input
  class="input-file-ui"
  style="padding: 0.5em"
  tooltipZIndex="2100"
  [escape]="false"
  [hideDelay]="250"
  [life]="3000"
  pTooltip="{{ tooltip }}"
  [showDelay]="500"
  [style.backgroundColor]="backgroundColorCss"
  [style.display]="displayCss"
  (contextmenu)="onContextMenu($event)"
  (press)="onContextMenu($any($event))">
  @if (isLabelDisplay) {
    <label
      iu-apiz-label
      [fontSize]="overridedCSS?.labelFontSize"
      [for]="uuid"
      [isFieldOnly]="data?.isFieldOnly"
      [label]="label">
      {{ label }}
    </label>
  }
  <iu-prime-fileupload
    [attr.data-cy-columnName]="data ? data.columnName : columnName"
    [auto]="auto"
    [canDelete]="canDelete"
    [canDownload]="canDownload"
    [canPreview]="canPreview"
    [canUpload]="canUpload"
    [customUpload]="true"
    [displayButtons]="displayButtons"
    [displayFileUploaded]="displayFileUploaded || isReadOnly"
    [displayedTags]="displayedTags"
    [fromDocServer]="fromDocServer"
    [inputId]="uuid"
    [isLoaderActive]="isLoaderActive"
    [isReadOnly]="isReadOnly"
    [linkedFiles]="linkedFiles"
    [multiple]="multiple"
    [overridedCSS]="overridedCSS"
    [styleClass]="styleClass"
    [supportLinks]="supportLinks"
    [uploadBtn_cancel]="uploadBtn_cancel"
    [uploadBtn_confirm]="uploadBtn_confirm"
    [uploadedFileList_noFiles]="uploadedFileList_noFiles"
    [uploadedFileList_title]="uploadedFileList_title"
    [uploadedFiles]="uploadedFiles"
    [uploadingFileList_drag]="uploadingFileList_drag"
    [uploadingFileList_title]="uploadingFileList_title"
    [uploadingFiles]="uploadingFiles"
    (attachUrl)="onAttachUrl($event.url, $event.tags)"
    (deleteEmitter)="deleteFile($event.file)"
    (downloadEmitter)="downloadFile($event.file)"
    (fileSelectEmitter)="onFileSelect($event)"
    (openFileOnSideEmitter)="openFileOnSide($event)"
    (uploadFiles)="uploadFiles($event)"
    (uploadHandler)="myUploader($event)" />
</div>
